import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import './Tabs.scss';
import React, { useCallback } from 'react';

const Tabs = (props) => {
  const { pages, activeTab, toggleTab, showAll = false } = props;

  const ANCHOR_KEY = 'anchorPane';

  const handleScrollToTarget = useCallback((targetId) => {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, []);

  return (
    <>
      <div className="tabs">
        <Nav tabs>
          {pages?.map((page, index) => (
            <NavItem key={page.id}>
              <NavLink
                className={showAll ? '' : activeTab === index ? 'active' : ''}
                onClick={() =>
                  showAll ? handleScrollToTarget(ANCHOR_KEY + page.id) : toggleTab(index)
                }
              >
                {page.label}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent activeTab={showAll ? undefined : activeTab}>
          {pages?.map((page, index) => (
            <TabPane
              id={ANCHOR_KEY + page.id}
              key={page.id}
              tabId={index}
              className={showAll ? 'show-all' : ''}
            >
              {typeof page.content === 'function' ? page.content() : page.content}
            </TabPane>
          ))}
        </TabContent>
      </div>
    </>
  );
};

export default Tabs;
